import FormEmail from '../../FormEmail/FormEmail';
import Social from '../../Social/Social';
import { ClassNameProps, EmailReques } from '../../../types/types';
import { useEffect, useState } from 'react';
import { socialItems } from '../../../data/data';

const ContactFooter = ({
  className,
  setIsRequestSent,
}: ClassNameProps & EmailReques) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 767.98) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className={className}>
      <div className='contact__info'>
        <div className='contact__inner'>
          <span className='text'>ContactPay Solution LTD,</span>
          <span className='text'>
            Mazars, 30 Old Bailey, London, United Kingdom,
          </span>
          <span className='text'>EC4M 7AU.</span>
        </div>
        <Social className='social' social={socialItems} />
        <div className='contact__description text-menu'>
          ContactPay Solution LTD, a company registered in the United Kingdom
          with company number 12149419 is authorized and regulated by the
          Financial Conduct Authority as an Electronic Money Institution.&nbsp;
          <a
            href='https://register.fca.org.uk/s/firm?id=0010X00004ijEuKQAU'
            rel='noopener noreferrer'
            target='_blank'
          >
            Firm Reference Number 901065.
          </a>
        </div>
      </div>
      <div className={`contact__card ${isMobile ? '' : 'card'}`}>
        <p className='contact__text text'>
          Get our guide with short and useful tips on how to choose a payment
          service provider for your business
        </p>
        <FormEmail
          className='contact__form form'
          source='Footer'
          setIsRequestSent={setIsRequestSent}
          buttonText='Get a guide!'
        />
      </div>
    </div>
  );
};
export default ContactFooter;
